








































































































































import Vue from 'vue';
import { VueTyper } from 'vue-typer';
import componentMixin from '@/utils/componentMixin';

export default Vue.extend({
	mixins: [componentMixin],
	components: {
		VueTyper,
	},
});
